import Chip from '@material-ui/core/Chip';

import { RiFileTextLine } from '@remixicon/react';

import { DocAttachment, attachmentKey } from '../../types';

import styles from './AttachmentChip.module.css';

interface AttachmentChipProps {
  attachment: DocAttachment;
  onRemove?: (key: string) => void;
  onClick?: (attachment: DocAttachment) => void;
}

export const AttachmentChip = ({
  attachment,
  onRemove,
  onClick,
}: AttachmentChipProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick(attachment);
      return;
    }
    if (attachment.uri) {
      window.open(attachment.uri, '_blank', 'noopener,noreferrer');
    }
  };
  return (
    <Chip
      className={styles.chip}
      size="small"
      label={attachment.title}
      icon={<RiFileTextLine size={14} className={styles.icon} />}
      onClick={attachment.uri || onClick ? handleClick : undefined}
      onDelete={
        onRemove ? () => onRemove(attachmentKey(attachment)) : undefined
      }
    />
  );
};
